import OptionalImage from '@src/components/optional-image';
import React from 'react';
import { observer } from 'mobx-react';
import ModalContainer from '@src/components/modal-container';
import cx from 'classnames';
import styles from './index.less';

const PreviewQrcodeModal = ({ store, onClose }) => {
  store.use(onClose);
  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={styles.content}>
        <div className={styles.close_btn} onClick={store.onModalClose} data-name="关闭按钮" />
        <div className={cx(styles.title_img, store.type)} data-name="标题" />
        <div>
          {store.type === 'custom_service' && (
            <div className={styles.tips}>
              扫码添加您的<span>客服管家</span>
            </div>
          )}
          {store.type === 'weixin' && (
            <div className={styles.tips}>
              扫码关注官方<span>微信公众号</span>
            </div>
          )}
        </div>
        <div className={styles.qrcode_box}>
          <OptionalImage className={styles.img} src={store.qrcodeImg} alt="二维码" />
        </div>
      </div>
    </ModalContainer>
  );
};

export default observer(PreviewQrcodeModal);
